import React from "react";
import TransVariable from "../other/TransVariable";
import styled from "styled-components/macro";
import HintDialog from "../hint/HintDialog";
import { useViewerQuery } from "../../queries/viewerQuery";
import { MANUALB2BSTOREID } from "sharedJs__generated/constants";

const Title = styled.p`
  font-size: 130%;
`;

const B2BWelcomeHint: React.FC = () => {
  const { viewer } = useViewerQuery();

  if (!viewer?.subscription || viewer.subscription.storeId !== MANUALB2BSTOREID) {
    return null;
  }

  const domain = viewer.email?.split("@")[1];
  if (!domain) return null;

  return (
    <HintDialog name="b2b-welcome" emoji="🎉">
      <Title>Congrats!</Title>
      <p>
        You were just promoted to Premium user thanks to your company <TransVariable text={<b>{domain}</b>} />.
      </p>
    </HintDialog>
  );
};

export default B2BWelcomeHint;
